/**
 * Keyboard focus indicator shared by every interactive component in the design
 * system.
 *
 * WCAG 2.2 SC 1.4.11 asks a focus indicator to reach 3:1 against the colours
 * next to it. The previous rings used `red-200` (#e88a99, 2.46:1 on white) and
 * `primary-300` (#c4b1e7), both under that bar; `purple-500` (#6633bb) measures
 * 7.62:1 on white and 6.99:1 on the app background. The 2px width and 2px offset
 * are the same everywhere, so the ring stays clear of the component's own fill
 * and stays legible on a purple button as well as on a light one.
 *
 * Use `focusRingReversed` on the brand's dark-purple surfaces, where the purple
 * ring would disappear: white reaches 15.87:1 there.
 *
 * These are Tailwind class strings (not twin.macro): this library is
 * className-based, so components interpolate the token into their `cn()`/cva
 * class lists.
 */
export const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-purple-500';

/** Focus indicator for components placed on dark or brand-coloured surfaces. */
export const focusRingReversed =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-white';
